import SEO from "../components/SEO";
import PageBanner from "../components/layout/PageBanner";
import Container from "../components/layout/Container";

const Privacy = () => (
  <main>
    <SEO title="Privacy Policy" description="Waterfront Cafe privacy policy." />
    <PageBanner title="Privacy Policy" eyebrow="Legal" text="How we handle enquiry and booking information." image="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=1600&q=80" />
    <section className="section legal-page">
      <Container>
        <h2>Privacy Policy</h2>

        <p><strong>Last Updated: June 2026</strong></p>

        <p>Waterfront Cafe respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how IVI Waterfronts Limited ("Waterfront Cafe", "we", "our", or "us") collects, uses, stores, and protects your information when you visit our website or contact us.</p>

        <h2>Who We Are</h2>

        <p>Waterfront Cafe is operated by IVI Waterfronts Limited.</p>

        <p><strong>Registered Company Name:</strong> IVI Waterfronts Limited</p>

        <p><strong>Company Number:</strong> 10265263</p>

        <p><strong>Address:</strong> A4074 Benson Waterfront, Wallingford, Oxfordshire, OX10 6SJ, United Kingdom</p>

        <p><strong>Email:</strong> <a href="mailto:info@waterfrontcafe.co.uk">info@waterfrontcafe.co.uk</a></p>

        <p><strong>Telephone:</strong> +44 (0) 1491 833 732</p>

        <p><strong>ICO Registration Number:</strong> ZB293769</p>

        <p>For the purposes of UK data protection legislation, IVI Waterfronts Limited is the Data Controller responsible for your personal information.</p>

        <h2>Information We Collect</h2>

        <p>When you use our website, we may collect limited information that you voluntarily provide to us or information automatically collected through your interaction with the website.</p>

        <h3>Information You Provide Directly</h3>

        <p>You may choose to provide:</p>

        <ul>
          <li>Full name</li>
          <li>Email address</li>
          <li>Telephone number</li>
          <li>Messages submitted through contact forms</li>
          <li>Enquiries regarding reservations, events, or services</li>
          <li>Any other information voluntarily provided when contacting us</li>
        </ul>

        <h3>Information Collected Automatically</h3>
{/* 
        <p>When you browse our website, certain technical information may be collected automatically, including:</p>

        <ul>
          <li>IP address</li>
          <li>Browser type and version</li>
          <li>Device information</li>
          <li>Operating system</li>
          <li>Website usage information</li>
          <li>Pages visited</li>
          <li>Date and time of visits</li>
          <li>Referring websites</li>
        </ul> */}

        <p>This information is generally collected in an aggregated and anonymous manner to help us improve the performance and functionality of our website.</p>

        <h2>How We Use Your Information</h2>

        <p>We may use personal information to:</p>

        <ul>
          <li>Respond to enquiries and requests.</li>
          <li>Provide information about our services.</li>
          <li>Respond to reservation enquiries.</li>
          <li>Improve website functionality and user experience.</li>
          <li>Monitor website security and performance.</li>
          <li>Prevent fraud and misuse of the website.</li>
          <li>Comply with legal obligations.</li>
        </ul>

        <h2>Lawful Basis for Processing</h2>

        <p>Under UK GDPR, we rely on one or more of the following lawful bases:</p>

        <h3>Consent</h3>

        <p>Where you voluntarily submit information through our contact forms or communications.</p>

        <h3>Legitimate Interests</h3>

        <p>To operate, maintain, improve, and secure our website and business operations.</p>

        <h3>Legal Obligation</h3>

        <p>Where processing is necessary to comply with applicable legal or regulatory requirements.</p>

        <h2>Sharing Your Information</h2>

        <p>We do not sell, rent, trade, or distribute personal information to third parties for marketing purposes.</p>

        <p>Information may be shared with trusted service providers who assist us with:</p>

        <ul>
          <li>Website hosting</li>
          <li>Website maintenance</li>
          <li>IT support</li>
          <li>Analytics services</li>
          <li>Professional advisers</li>
        </ul>

        <p>All service providers are required to process personal information securely and only for authorised purposes.</p>

        <h2>International Transfers</h2>

        <p>Some third-party service providers may process information outside the United Kingdom.</p>

        <p>Where such transfers occur, appropriate safeguards are implemented in accordance with GDPRrequirements.</p>

        <h2>Data Retention</h2>

        <p>We retain personal information only for as long as necessary to fulfil the purposes outlined in this Privacy Policy or to comply with legal obligations.</p>

        <p>Typical retention periods may include:</p>

        <ul>
          <li>Website enquiries: up to 12 months</li>
          <li>Customer correspondence: up to 24 months</li>
          <li>Legal and regulatory records: as required by law</li>
          <li>Analytics information: according to service provider retention settings</li>
        </ul>

        <h2>Security</h2>

        <p>We maintain reasonable technical and organisational measures to protect personal information from unauthorised access, disclosure, misuse, alteration, or destruction.</p>

        <p>While we take reasonable precautions, no method of internet transmission or electronic storage can be guaranteed to be completely secure.</p>

        <h2>Your Rights</h2>

        <p>Under UK GDPR, you have the right to:</p>

        <ul>
          <li>Access your personal information.</li>
          <li>Correct inaccurate information.</li>
          <li>Request deletion of your information.</li>
          <li>Restrict processing.</li>
          <li>Object to processing.</li>
          <li>Withdraw consent where applicable.</li>
          <li>Request portability of your information.</li>
          <li>Lodge a complaint with the Information Commissioner's Office (ICO).</li>
        </ul>

        <h2>Children's Privacy</h2>

        <p>Our website is intended for general audiences and is not specifically directed towards children under the age of 13.</p>

        <p>We do not knowingly collect personal information from children without appropriate parental consent.</p>

        <h2>Contact Us</h2>

        <p>If you have any questions regarding this Privacy Policy or your personal information, please contact:</p>

        <p><strong>Email:</strong> <a href="mailto:info@waterfrontcafe.co.uk">info@waterfrontcafe.co.uk</a></p>

        <p><strong>Telephone:</strong> +44 (0) 1491 833 732</p>

        <p><strong>Address:</strong> A4074 Benson Waterfront, Wallingford, Oxfordshire, OX10 6SJ, United Kingdom</p>
      </Container>
    </section>
  </main>
);

export default Privacy;
